<ng-container *transloco="let t">
    <div class="d-flex flex-column align-items-center" *ngIf="status === 'working'">
        <mat-progress-spinner [diameter]="72" color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
    <div *ngIf="status === 'success'">
        <td-alert [title]="t('notifications-unsubscribe.success-title')" state="success">{{ t('notifications-unsubscribe.success') }}</td-alert>
    </div>
    <div *ngIf="status === 'KeyNotFound'">
        <td-error [title]="t('notifications-unsubscribe.error-title')" [message]="t('notifications-unsubscribe.invalid-key')"></td-error>
    </div>
    <div *ngIf="status === 'error'">
        <td-error [title]="t('notifications-unsubscribe.error-title')" [message]="t('notifications-confirm.unknown-error')"></td-error>
    </div>
    <div class="mt-4 d-flex flex-column align-items-center">
        <a mat-stroked-button color="primary" [routerLink]="['/']">
            <fa-icon icon="layer-group"></fa-icon>
            {{ t('general.go-to-dashboard') }}
        </a>
    </div>
</ng-container>
